import { render, staticRenderFns } from "./Mutation.vue?vue&type=template&id=39e4cf95&scoped=true&"
import script from "./Mutation.vue?vue&type=script&lang=js&"
export * from "./Mutation.vue?vue&type=script&lang=js&"
import style0 from "./Mutation.vue?vue&type=style&index=0&id=39e4cf95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4cf95",
  null
  
)

export default component.exports